import * as React from "react";
import "./project-edit.css";
import { KeyValueStore } from "../../../stores/key-value/key-value-store";
import { Contact } from "../../../stores/contact/contact-store";
import { LandfillSiteProject } from "../../../stores/project/project";
import { Grid, GridColumn, GridRow, Input } from "semantic-ui-react";
import LabeledInput from "../../../components/labeled-input/labeled-input";
import MyDatePicker from "../../../components/date-picker/date-picker";
import LabeledTextArea from "../../../components/labeled-textarea/labeled-textarea";
import LabeledValue from "../../../components/labeled-value/labeled-value";
import { Municipality } from "../../../stores/municipality/municipality-store";
import { getDesc, getLabel } from "../../../reflection/reflection";

export default function LandfillSiteEdit({
                                             project,
                                             municipalities,
                                             contacts,
                                             keyValueStore
                                         }: {
    project: LandfillSiteProject;
    municipalities: Municipality[];
    contacts: Contact[],
    keyValueStore: KeyValueStore
}): JSX.Element {
    return (
        <div>
            <Grid columns={2} relaxed={true} stackable={true}>
                <GridRow>
                    <GridColumn largeScreen={16} widescreen={8}>
                        <LabeledValue
                            label={getLabel(project, "fullType")}
                            value={project.type}
                            required={true}/>
                        <LabeledInput
                            label="Name"
                            inputElement={
                                <Input
                                    type="text"
                                    name="name"
                                    defaultValue={project.name}
                                />
                            }
                            required={true}
                        />
                        <LabeledInput
                            label={getLabel(project, "municipalityName")}
                            desc={getDesc(project, "municipalityName")}
                            inputElement={
                                <select name="municipality" className="ui selection dropdown">
                                    <option disabled selected={project.municipality === undefined}>
                                        -- Auswählen --
                                    </option>
                                    {municipalities.map((m) => (
                                        <option
                                            key={m.bfsNr}
                                            value={m.bfsNr}
                                            selected={project.municipality?.bfsNr === m.bfsNr}
                                        >
                                            {m.name}
                                        </option>
                                    ))}
                                </select>
                            }
                            required={true}
                        />
                        <LabeledInput
                            label={getLabel(project, "place")}
                            desc={getDesc(project, "place")}
                            inputElement={<Input type="text" name="place" defaultValue={project.place}/>}
                            required={true}
                        />
                        <LabeledInput
                            label={getLabel(project, "landfillSiteType")}
                            desc={getDesc(project, "landfillSiteType")}
                            inputElement={
                                <select
                                    name="landfillSiteType"
                                    className="ui selection dropdown"
                                >
                                    <option disabled selected={project.projectDto.landfillSiteType === null}>
                                        -- Auswählen --
                                    </option>
                                    {keyValueStore.landfillSiteTypes.map((s) => (
                                        <option
                                            key={s.key}
                                            value={s.key}
                                            selected={project.projectDto.landfillSiteType === s.key}
                                        >
                                            {s.value}
                                        </option>
                                    ))}
                                </select>
                            }
                            required={true}
                        />
                        <LabeledInput
                            label={getLabel(project, "status")}
                            desc={getDesc(project, "status")}
                            inputElement={
                                <select name="status" className="ui selection dropdown">
                                    {keyValueStore.projectStatuses.map((s) => (
                                        <option
                                            key={s.key}
                                            value={s.key}
                                            selected={project.projectDto.status === s.key}
                                        >
                                            {s.value}
                                        </option>
                                    ))}
                                </select>
                            }
                            required={true}
                        />
                        <LabeledInput
                            label={getLabel(project, "governmentCouncilDecisionNr")}
                            desc={getDesc(project, "governmentCouncilDecisionNr")}
                            inputElement={<Input type="text" name="governmentCouncilDecisionNr"
                                                 defaultValue={project.governmentCouncilDecisionNr}/>}
                        />
                        <LabeledInput
                            label={getLabel(project, "ebageNr")}
                            desc={getDesc(project, "ebageNr")}
                            inputElement={<Input type="text" name="ebageNr" defaultValue={project.ebageNr}/>}
                        />
                        <LabeledInput
                            label={getLabel(project, "enactmentDateDisplayText")}
                            desc={getDesc(project, "enactmentDateDisplayText")}
                            inputElement={<MyDatePicker name="enactmentDate"
                                                        value={project.enactmentDate}/>}
                        />
                        <LabeledInput
                            label={getLabel(project, "constructionPermitDateDisplayText")}
                            desc={getDesc(project, "constructionPermitDateDisplayText")}
                            inputElement={<MyDatePicker name="constructionPermitDate"
                                                        value={project.constructionPermitDate}/>}
                        />
                        <LabeledInput
                            label={getLabel(project.recultivationProject, "approvedCreationArea")}
                            desc={getDesc(project.recultivationProject, "approvedCreationArea")}
                            inputElement={<Input type="number" name="approvedCreationArea"
                                                 defaultValue={project.recultivationProject.approvedCreationArea}/>}
                        />
                        <LabeledInput
                            label={getLabel(project.recultivationProject, "creationGoalSource")}
                            inputElement={
                                <select name="creationGoalSource" className="ui selection dropdown">
                                    <option
                                        key={-1}
                                        value=""
                                        selected={project.recultivationProject.projectDto.creationGoalSource === null}>
                                        -- Auswählen --
                                    </option>
                                    {keyValueStore.creationGoalSources.map(e => (
                                        <option
                                            key={e.key}
                                            value={e.key}
                                            selected={project.recultivationProject.projectDto.creationGoalSource === e.key}
                                        >{e.value}</option>
                                    ))}
                                </select>
                            }
                        />
                        <LabeledInput
                            label={getLabel(project, "cmiDocumentsRawiPre")}
                            desc={getDesc(project, "cmiDocumentsRawiPre")}
                            inputElement={<Input type="text" name="cmiNrRawiPre"
                                                 defaultValue={project.cmiDocumentsRawiPre.join(", ")}/>}
                            required={true}
                        />
                        <LabeledInput
                            label={getLabel(project, "cmiDocumentsUwePre")}
                            desc={getDesc(project, "cmiDocumentsUwePre")}
                            inputElement={<Input type="text" name="cmiNrUwePre"
                                                 defaultValue={project.cmiDocumentsUwePre.join(", ")}/>}
                        />
                    </GridColumn>
                    <GridColumn>
                        <LabeledInput
                            label={getLabel(project, "cmiDocumentsRawiApproved")}
                            desc={getDesc(project, "cmiDocumentsRawiApproved")}
                            inputElement={<Input type="text" name="cmiNrRawiApproved"
                                                 defaultValue={project.cmiDocumentsRawiApproved.join(", ")}/>}
                        />
                        <LabeledInput
                            label={getLabel(project, "cmiDocumentsUweApproved")}
                            desc={getDesc(project, "cmiDocumentsUweApproved")}
                            inputElement={<Input type="text" name="cmiNrUweApproved"
                                                 defaultValue={project.cmiDocumentsUweApproved.join(",")}/>}
                        />
                        <LabeledInput
                            label={getLabel(project, "geometrySource")}
                            desc={getDesc(project, "geometrySource")}
                            inputElement={<Input type="text" maxLength={50} name="geometrySource"
                                                 defaultValue={project.geometrySource}/>}
                        />
                        <LabeledInput
                            label={getLabel(project, "geometrySourceDateDisplayText")}
                            desc={getDesc(project, "geometrySourceDateDisplayText")}
                            inputElement={<MyDatePicker name="geometrySourceDate" value={project.geometrySourceDate}/>}
                        />
                        <LabeledInput
                            label={getLabel(project.recultivationProject, "approvedRecultivationArea")}
                            desc={getDesc(project.recultivationProject, "approvedRecultivationArea")}
                            inputElement={<Input type="number" name="approvedRecultivationArea"
                                                 defaultValue={project.recultivationProject.approvedRecultivationArea}/>}
                        />
                        <LabeledInput
                            label={getLabel(project.recultivationProject, "constructionSupervisorFullName")}
                            inputElement={
                                <select name="constructionSupervisorId" className="ui selection dropdown">
                                    <option
                                        key={-1}
                                        value=""
                                        selected={project.recultivationProject.constructionSupervisor === undefined}>
                                        -- Auswählen --
                                    </option>
                                    {contacts.map(c => (
                                        <option
                                            key={c.id}
                                            value={c.id}
                                            selected={project.recultivationProject.constructionSupervisor?.id === c.id}
                                        >{`${c.firstName} ${c.lastName}`}</option>
                                    ))}
                                </select>
                            }
                        />
                        <LabeledInput
                            label={getLabel(project.recultivationProject, "operatingPermitDateDisplayText")}
                            desc={getDesc(project.recultivationProject, "operatingPermitDateDisplayText")}
                            inputElement={<MyDatePicker name="operatingPermitDate"
                                                        value={project.recultivationProject.operatingPermitDate}/>}
                        />
                        <LabeledInput
                            label={getLabel(project.recultivationProject, "maintenanceDirectiveDateDisplayText")}
                            desc={getDesc(project.recultivationProject, "maintenanceDirectiveDateDisplayText")}
                            inputElement={<MyDatePicker name="maintenanceDirectiveDate"
                                                        value={project.recultivationProject.maintenanceDirectiveDate}/>}
                        />
                        <LabeledInput
                            label={getLabel(project.recultivationProject, "requirementsSpecificationBBBStatus")}
                            desc={getDesc(project.recultivationProject, "requirementsSpecificationBBBStatus")}
                            inputElement={
                                <select name="requirementsSpecificationBBBStatus" className="ui selection dropdown">
                                    <option
                                        key={-1}
                                        value=""
                                        selected={project.recultivationProject.projectDto.requirementsSpecificationBBBStatus === null}>
                                        -- Auswählen --
                                    </option>
                                    {keyValueStore.conditionControlStatuses.map(e => (
                                        <option
                                            key={e.key}
                                            value={e.key}
                                            selected={project.recultivationProject.projectDto.requirementsSpecificationBBBStatus === e.key}
                                        >{e.value}</option>
                                    ))}
                                </select>
                            }
                        />
                        <LabeledInput
                            label={getLabel(project.recultivationProject, "requirementsSpecificationRequestSource")}
                            desc={getDesc(project.recultivationProject, "requirementsSpecificationRequestSource")}
                            inputElement={
                                <select name="requirementsSpecificationRequestSource" className="ui selection dropdown">
                                    <option
                                        key={-1}
                                        value=""
                                        selected={project.recultivationProject.projectDto.requirementsSpecificationRequestSource === null}>
                                        -- Auswählen --
                                    </option>
                                    {keyValueStore.conditionControlSources.map(e => (
                                        <option
                                            key={e.key}
                                            value={e.key}
                                            selected={project.recultivationProject.projectDto.requirementsSpecificationRequestSource === e.key}
                                        >{e.value}</option>
                                    ))}
                                </select>
                            }
                        />
                        <LabeledInput
                            label={getLabel(project.recultivationProject, "startConstructionMeetingStatus")}
                            desc={getDesc(project.recultivationProject, "startConstructionMeetingStatus")}
                            inputElement={
                                <select name="startConstructionMeetingStatus" className="ui selection dropdown">
                                    <option
                                        key={-1}
                                        value=""
                                        selected={project.recultivationProject.projectDto.startConstructionMeetingStatus === null}>
                                        -- Auswählen --
                                    </option>
                                    {keyValueStore.conditionControlStatuses.map(e => (
                                        <option
                                            key={e.key}
                                            value={e.key}
                                            selected={project.recultivationProject.projectDto.startConstructionMeetingStatus === e.key}
                                        >{e.value}</option>
                                    ))}
                                </select>
                            }
                        />
                        <LabeledInput
                            label={getLabel(project.recultivationProject, "startConstructionMeetingSource")}
                            desc={getDesc(project.recultivationProject, "startConstructionMeetingSource")}
                            inputElement={
                                <select name="startConstructionMeetingSource" className="ui selection dropdown">
                                    <option
                                        key={-1}
                                        value=""
                                        selected={project.recultivationProject.projectDto.startConstructionMeetingSource === null}>
                                        -- Auswählen --
                                    </option>
                                    {keyValueStore.conditionControlSources.map(e => (
                                        <option
                                            key={e.key}
                                            value={e.key}
                                            selected={project.recultivationProject.projectDto.startConstructionMeetingSource === e.key}
                                        >{e.value}</option>
                                    ))}
                                </select>
                            }
                        />
                    </GridColumn>
                </GridRow>
                <GridRow>
                    <GridColumn>
                        <LabeledTextArea label={getLabel(project, "remarks")}
                                         name="remarks"
                                         defaultValue={project.remarks}/>
                        <LabeledTextArea label={getLabel(project.recultivationProject, "enactmentRemarks")}
                                         name="enactmentRemarks"
                                         defaultValue={project.recultivationProject.enactmentRemarks}/>
                        <LabeledTextArea label={getLabel(project.recultivationProject, "creationGoalRemarks")}
                                         name="creationGoalRemarks"
                                         defaultValue={project.recultivationProject.creationGoalRemarks}/>
                    </GridColumn>
                </GridRow>
            </Grid>
        </div>
    )
        ;
}
